module.exports = __webpack_public_path__ + "static/img/8.4326a2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/eng/8.png
// module id = aQyP
// module chunks = 0